import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { formatWidgetValue, formatPercentage } from '../../../services/dashboardsService';

const KpiWidget = ({ data }) => {
  const { value, label, format, delta, delta_label, trend, summary } = data || {};

  // Solo mostramos ícono de tendencia si hay tendencia real (up/down).
  // En KPIs de conteo puro (Competidores, UPCs) no hay trend y antes
  // mostrábamos un "−" feo. Ahora simplemente no mostramos ícono.
  const showTrendIcon = trend === 'up' || trend === 'down';
  const TrendIcon = trend === 'up' ? FaArrowUp : FaArrowDown;

  const trendClass =
    trend === 'up' ? 'kpi-trend-up' :
    trend === 'down' ? 'kpi-trend-down' :
    'kpi-trend-neutral';

  return (
    <div className="kpi-widget-body">
      <div className={`kpi-widget-value ${trendClass}`}>
        {showTrendIcon && <TrendIcon className="kpi-widget-trend-icon" />}
        <span className="kpi-widget-number">{formatWidgetValue(value, format)}</span>
      </div>
      {label && <div className="kpi-widget-label">{label}</div>}
      {(delta !== null && delta !== undefined && !isNaN(Number(delta))) && (
        <div className={`kpi-widget-delta ${trendClass}`}>
          {formatPercentage(delta)} {delta_label || ''}
        </div>
      )}
      {summary && <div className="kpi-widget-summary">{summary}</div>}
    </div>
  );
};

export default KpiWidget;
